import {Component, Input, OnInit} from '@angular/core';
import {MypageService} from 'src/app/modules/services/mypage/mypage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';

import {Location} from '@angular/common';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {isEmpty} from '../../../../utils/is-empty';
import {MontantPipe} from '../../../../modules/pipes/pipes/montant.pipe';

type Column = keyof any;

@Component({
    selector: 'app-etat-inscription-fourn',
    templateUrl: './etat-inscription-fourn.component.html',
    styleUrls: ['./etat-inscription-fourn.component.css'],
    providers: [MontantPipe],
})
export class EtatInscriptionFournComponent implements OnInit {
    @Input() bizRegNo;
    dataG = [];
    dataDoc = [];
    label = 'Etat Fournisseur';
    dataEtat = [];
    dataColumns: Column[] = ['num', 'excDtStr', 'cdNmFr', '', '', ''];
    dataColumnsAr: Column[] = ['num', 'excDtStr', 'cdNmAr', '', '', ''];
    dataColumnsEn: Column[] = ['num', 'excDtStr', 'cdNm', '', '', ''];
    labels: Partial<Record<Column, string>> = {
        num: 'N°',
        excDtStr: 'Date Enregistrement',
        cdNm: 'Etat Fournisseur',
        d: 'Date Début',
        a: 'Date Clôture',
        b: 'Remarque',
    };
    labelsDoc = ['docNo', 'reqDt'];
    labelsDeroul = ['Etat déroulement'];
    dataColumnsDocFr: Column[] = ['docNo', 'reqDt'];
    dataColumnsDeroulAr: Column[] = ['formeDeroulementAr'];
    dataColumnsDeroulEn: Column[] = ['formeDeroulementEn'];
    dataColumnsDeroulFr: Column[] = ['formeDeroulementFr'];
    // ];
    labelInfoUsine = 'Etat Fournisseur';
    dataInfoUsine = [];
    // labels = [
    //   'N°',
    //   'Date Enregistrement',
    //   'Etat Fournisseur',
    //   'Date Début',
    //   'Date Clôture',
    //   'Remarque',
    dataColumnsInfoUsine = ['num', 'excDtStr', 'cdNmFr', '', '', ''];
    dataColumnsInfoUsineAr = ['num', 'excDtStr', 'cdNmAr', '', '', ''];
    dataColumnsInfoUsineEn = ['num', 'excDtStr', 'cdNm', '', '', ''];
    labelsInfoUsine = [
        'N°',
        'Date Enregistrement',
        'Etat Fournisseur',
        'Date Début',
        'Date Clôture',
        'Remarque',
    ];
    labelPremierResp = 'Etat Fournisseur';
    dataPremRes = [];
    dataColumnsPremRes = ['chfNm', 'indRegNo', 'issuedYmd', 'mtelNo', 'email'];
    dataColumnsArPremRes = ['chfNm', 'indRegNo', 'issuedYmd', 'mtelNo', 'email'];
    dataColumnsEnPremRes = ['chfNm', 'indRegNo', 'issuedYmd', 'mtelNo', 'email'];
    labelsPremRes = [
        'Nom Et Prénom',
        'N° CIN',

        'Date de délivrance',
        'N° Tel Portable',
        'Email Premier Responsable',
    ];
    list = [];
    dataItemProd = [];
    dataMandSoum = [];
    dataLicense = [];
    dataUsine = [];
    k = 0;
    j = 0;
    l = 0;
    n = 0;
    show = false;

    constructor(
        private myPageService: MypageService,
        private activatedRoute: ActivatedRoute,
        private appTranslateService: AppTranslateService,
        private toast: ToastService,
        private _location: Location,
        private confirmDialogService: ConfirmDialogService,
        private route: Router,
        private montant: MontantPipe
    ) {
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params) => {
            if (params.bizRegNo != null) {
                this.bizRegNo = params.bizRegNo;
            }
            // console.log("ssss",this.movement)
        });
        this.getdetail();
    }

    getdetail() {
        this.myPageService.loadUserInfoFourPortail(this.bizRegNo).subscribe({
            next: (data) => {

                data['umSupplier'].regReplyEmail =
                    data['umSupplierEdocInfo'].regReplyEmail;
                this.dataG = [data['umSupplier']];
                if (!isEmpty(this.dataG[0].capitalAmt)) {
                    this.dataG[0].capitalAmt = this.montant.transform(
                        this.dataG[0].capitalAmt
                    );
                }
                if (this.dataG[0]?.national != 'TUN') {
                    this.labelsPremRes.forEach((x, i) => {
                        if (x == 'N° CIN') {
                            this.labelsPremRes[i] = 'passport';
                        }
                    });
                }



                this.dataEtat = data['listUmSupplierState'];
                this.list = data['lst'];
                this.list.filter((check) => {
                    if (check.exist == 'Y') {
                        check.exist = true;
                    } else if (check.exist == 'N') {
                        check.exist = false;
                    }
                });
                this.dataItemProd = data['listUmSupplierItem'];
                this.dataMandSoum = data['listUmAttorney'];
                this.dataLicense = data['listUmLicense'];
                this.dataUsine = data['listUmFactory'];
                this.dataDoc = [data['umSupplierEdocInfo']];

                let i = 0;
                let k = 0;
                let m = 0;
                let d = 0;
                if (this.dataUsine != []) {
                    this.dataUsine.filter((res) => {
                        res.num = d + 1;
                        res.addr2 = res.addr2 + ' , ' + res.addr1;
                        d = d + 1;
                    });
                }
                if (this.dataLicense != []) {
                    this.dataLicense.filter((res) => {
                        res.num = m + 1;
                        m = m + 1;
                    });
                }
                if (this.dataMandSoum != []) {
                    this.dataMandSoum.filter((res) => {
                        res.num = k + 1;
                        k = k + 1;
                    });
                }
                if (this.dataItemProd != []) {
                    this.dataItemProd.filter((res) => {
                        if (res.makeFl == 'Y') {
                            res.makeFl = 'Fabricant';
                        } else if (res.makeFl == 'N') {
                            res.makeFl = 'Revendeur';
                        }
                        res.num = i + 1;
                        i = i + 1;
                    });
                }
                this.dataPremRes = [data['umChief']];
                let j = 0;
                this.dataEtat.filter((res) => {
                    res.num = j + 1;
                    j = j + 1;
                });
            },
        });
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    retourListe() {
        this._location.back();
    }

    supprimer() {
        this.myPageService.annulerDemande(this.bizRegNo).subscribe({
            next: (res) => {
            },
            error: () => {
                this.toast.error();
            },
            complete: () => {
                this.retourListe();
                this.toast.success('saved_successfully');
                // this.routee.navigateByUrl("acheteur/avisao/add/details");
            },
        });
    }

    signer() {
        this.show = !this.show;
    }

    send(data) {
        this.confirmDialogService
            .confirm('Confirmation', 'Voulez-vous confirmer cette opération ?')
            .subscribe((res) => {
                if (res) {
                    this.myPageService.getCookie(data[0].alias).subscribe({
                        error: (err) => {
                            const cookie = err.error.text;
                            {
                                let list = {
                                    domValues: [
                                        {
                                            domName: 'R_H_10_20_10',
                                            domValue: 'C0000000000000',
                                        },
                                        {
                                            domName: 'R_H_10_20_20_10',
                                            domValue: 'Supplier registration requirement ',
                                        },
                                        {
                                            domName: 'R_H_10_20_20_20',
                                            domValue: 'supplier@test.com  ',
                                        },
                                        {
                                            domName: 'R_H_10_20_20_40',
                                            domValue: '00000000',
                                        },
                                        {
                                            domName: 'R_H_10_20_20_50',
                                            domValue: 'Seller',
                                        },
                                        {
                                            domName: 'R_H_10_30',
                                            domValue: '1',
                                        },
                                        {
                                            domName: 'R_H_10_30_10',
                                            domValue: 'G1000001963001',
                                        },
                                        {
                                            domName: 'R_H_10_30_20_10',
                                            domValue: 'Nizar Abdelli',
                                        },
                                        {
                                            domName: 'R_H_10_30_20_20',
                                            domValue: 'nizar.abdelli@pm.gov.tn',
                                        },
                                        {
                                            domName: 'R_H_10_30_20_40',
                                            domValue: '71566564',
                                        },
                                        {
                                            domName: 'R_H_10_30_20_50',
                                            domValue: 'Center',
                                        },
                                        {
                                            domName: 'R_H_10_40_10',
                                            domValue: '0',
                                        },
                                        {
                                            domName: 'R_H_10_40_20',
                                            domValue: '1.0',
                                        },
                                        {
                                            domName: 'R_H_10_40_30',
                                            domValue: 'RegistrationApplication',
                                        },
                                        {
                                            domName: 'R_H_10_40_40',
                                            domValue: 'U',
                                        },
                                        {
                                            domName: 'R_H_10_40_50',
                                            domValue: this.dataDoc[0]?.docNo?.toString(),
                                        },
                                        {
                                            domName: 'R_H_10_40_60',
                                            domValue: this.dataDoc[0].reqDt?.toString(),
                                        },
                                        {
                                            domName: 'R_H_10_60_10_20',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_10_10',
                                            domValue: this.dataG[0].taxId?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_20',
                                            domValue: this.dataG[0].supplierNm?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_30',
                                            domValue: this.dataG[0].bizRegNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_40',
                                            domValue: this.dataG[0].cnssId?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_50',
                                            domValue: this.dataG[0].artisanNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_60',
                                            domValue: this.dataG[0].corporationCl?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_70',
                                            domValue: this.dataG[0].bizClStr?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_80',
                                            domValue: this.dataG[0].supplierCl?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_90',
                                            domValue: this.dataG[0].corporationCl?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_100',
                                            domValue: this.dataG[0].bizCl?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_100',
                                            domValue: this.dataG[0].supplierCl?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_120',
                                            domValue: '1',
                                        },
                                        {
                                            domName: 'R_B_10_130',
                                            domValue: this.dataG[0].openYmdStr?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_140',
                                            domValue: this.dataG[0].commercialNm?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_150',
                                            domValue: this.dataG[0].capitalAmt?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_160_10',
                                            domValue: this.dataG[0].bizRegYmdStr?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_160_20',
                                            domValue: this.dataG[0].national?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_160_30',
                                            domValue: this.dataG[0].nationalFr?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_160_40_10',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_10_170_10',
                                            domValue: this.dataG[0].postCd?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_170_20',
                                            domValue: this.dataG[0].addr1?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_170_30',
                                            domValue: this.dataG[0].addr2?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_180_10_10',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_10_180_10_20',
                                            domValue: this.dataG[0].hpage?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_180_10_30',
                                            domValue: this.dataG[0].telNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_180_10_40',
                                            domValue: this.dataG[0].faxNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_10_180_10_50',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_10_190_10',
                                            domValue: this.dataG[0].employeeNum?.toString(),
                                        },
                                        {
                                            domName: 'R_B_20_10',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_20_20_10_10',
                                            domValue: this.dataDoc[0].regReplyEmail?.toString(),
                                        },
                                        {
                                            domName: 'R_B_20_20_10_20',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_20_20_10_30',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_20_20_10_40',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_20_20_10_50',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_30_10',
                                            domValue: this.dataPremRes[0].indRegNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_30_20',
                                            domValue: this.dataPremRes[0].chfNm?.toString(),
                                        },
                                        {
                                            domName: 'R_B_30_30',
                                            domValue: this.dataPremRes[0].issuedYmdStr?.toString(),
                                        },
                                        {
                                            domName: 'R_B_30_40_10',
                                            domValue: this.dataPremRes[0].email?.toString(),
                                        },
                                        {
                                            domName: 'R_B_30_40_20',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_30_40_30',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_30_40_40',
                                            domValue: '',
                                        },
                                        {
                                            domName: 'R_B_30_40_50',
                                            domValue: this.dataPremRes[0].mtelNo?.toString(),
                                        },
                                        {
                                            domName: 'R_B_40',
                                            domValue: this.dataUsine.length?.toString(),
                                        },
                                        {
                                            domName: 'R_B_50',
                                            domValue: this.dataItemProd.length?.toString(),
                                        },
                                        {
                                            domName: 'R_B_60',
                                            domValue: this.dataLicense.length?.toString(),
                                        },
                                        {
                                            domName: 'R_B_70',
                                            domValue: this.dataMandSoum.length?.toString(),
                                        },
                                    ],
                                    cookie: cookie.toString(),
                                    // cookie: "acheteur1&com.ngtech.tuneps.ksign.TokenSunMSCAPI",
                                };

                                if (this.dataUsine.length > 1) {
                                    this.dataUsine.forEach((e, i) => {
                                        this.k = this.k + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_40_10' + '[' + i + ']',
                                                    domValue: i + 1,
                                                },
                                                {
                                                    domName: 'R_B_40_20' + '[' + i + ']',
                                                    domValue: e.factoryNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_10' + '[' + i + ']',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_20' + '[' + i + ']',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_30' + '[' + i + ']',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_40' + '[' + i + ']',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_50' + '[' + i + ']',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_40_10' + '[' + i + ']',
                                                    domValue: e.postCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_20' + '[' + i + ']',
                                                    domValue: e.addr1?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_30' + '[' + i + ']',
                                                    domValue: e.addr2?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else if (this.dataUsine.length == 1) {
                                    this.dataUsine.forEach((e, i) => {
                                        this.k = this.k + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_40_10',
                                                    domValue: '1',
                                                },
                                                {
                                                    domName: 'R_B_40_20',
                                                    domValue: e.factoryNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_10',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_20',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_30',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_40',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_50',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_40_10',
                                                    domValue: e.postCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_20',
                                                    domValue: e.addr1?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_30',
                                                    domValue: e.addr2?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else {
                                    const t = {
                                        domValues: [
                                            {
                                                domName: 'R_B_40_10',
                                                domValue: '0',
                                            },
                                            {
                                                domName: 'R_B_40_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_10',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_50',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_10',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_30',
                                                domValue: '',
                                            },
                                        ],
                                    };
                                    t.domValues.forEach((t, index) => {
                                        list.domValues.push(t);
                                    });
                                }

                                if (this.dataItemProd.length > 1) {
                                    this.dataItemProd.forEach((e, i) => {
                                        this.j = this.j + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_50_10' + '[' + i + ']',
                                                    domValue: i + 1,
                                                },
                                                {
                                                    domName: 'R_B_50_20' + '[' + i + ']',
                                                    domValue: e.cateId?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_50_30' + '[' + i + ']',
                                                    domValue: e.cateNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_50_40' + '[' + i + ']',
                                                    domValue: e.makeFl?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_30' + '[' + i + ']',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_40' + '[' + i + ']',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_50' + '[' + i + ']',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_40_10' + '[' + i + ']',
                                                    domValue: e.postCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_20' + '[' + i + ']',
                                                    domValue: e.addr1?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_30' + '[' + i + ']',
                                                    domValue: e.addr2?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else if (this.dataItemProd.length == 1) {
                                    this.dataItemProd.forEach((e, i) => {
                                        this.j = this.j + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_50_10',
                                                    domValue: '1',
                                                },
                                                {
                                                    domName: 'R_B_50_20',
                                                    domValue: e.cateId?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_50_30',
                                                    domValue: e.cateNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_50_40',
                                                    domValue: e.makeFl?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_30',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_40',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_30_10_50',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_40_40_10',
                                                    domValue: e.postCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_20',
                                                    domValue: e.addr1?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_40_40_30',
                                                    domValue: e.addr2?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else {
                                    const t = {
                                        domValues: [
                                            {
                                                domName: 'R_B_50_10',
                                                domValue: '0',
                                            },
                                            {
                                                domName: 'R_B_50_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_50_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_50_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_30_10_50',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_10',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_40_40_30',
                                                domValue: '',
                                            },
                                        ],
                                    };
                                    t.domValues.forEach((t, index) => {
                                        list.domValues.push(t);
                                    });
                                }

                                if (this.dataLicense.length > 1) {
                                    this.dataLicense.forEach((e, i) => {
                                        this.l = this.l + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_60_10' + '[' + i + ']',
                                                    domValue: i + 1,
                                                },
                                                {
                                                    domName: 'R_B_60_20' + '[' + i + ']',
                                                    domValue: e.licenseCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_30' + '[' + i + ']',
                                                    domValue: e.licenseRegNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_40' + '[' + i + ']',
                                                    domValue: e.licenseNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_50' + '[' + i + ']',
                                                    domValue: e.issuedInst?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_60_10' + '[' + i + ']',
                                                    domValue: e.issuedYmdStr?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_60_20' + '[' + i + ']',
                                                    domValue: e.expirationYmdStr?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else if (this.dataLicense.length == 1) {
                                    this.dataItemProd.forEach((e, i) => {
                                        this.l = this.l + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_60_10',
                                                    domValue: i + 1,
                                                },
                                                {
                                                    domName: 'R_B_60_20',
                                                    domValue: e.licenseCd?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_30',
                                                    domValue: e.licenseRegNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_40',
                                                    domValue: e.licenseNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_50',
                                                    domValue: e.issuedInst?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_60_10',
                                                    domValue: e.issuedYmdStr?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_60_60_20',
                                                    domValue: e.expirationYmdStr?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else {
                                    const t = {
                                        domValues: [
                                            {
                                                domName: 'R_B_60_10',
                                                domValue: '0',
                                            },
                                            {
                                                domName: 'R_B_60_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_60_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_60_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_60_50',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_60_60_10',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_60_60_20',
                                                domValue: '',
                                            },
                                        ],
                                    };
                                    t.domValues.forEach((t, index) => {
                                        list.domValues.push(t);
                                    });
                                }
                                if (this.dataMandSoum.length > 1) {
                                    this.dataMandSoum.forEach((e, i) => {
                                        this.n = this.n + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_70_10' + '[' + i + ']',
                                                    domValue: i + 1,
                                                },
                                                {
                                                    domName: 'R_B_70_20' + '[' + i + ']',
                                                    domValue: e.indRegNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_30' + '[' + i + ']',
                                                    domValue: e.staffNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_40' + '[' + i + ']',
                                                    domValue: e.positionNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_50' + '[' + i + ']',
                                                    domValue: e.issuedYmdStr?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_10' + '[' + i + ']',
                                                    domValue: e.email?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_20' + '[' + i + ']',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_30' + '[' + i + ']',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_40' + '[' + i + ']',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_50' + '[' + i + ']',
                                                    domValue: e.mtelNo?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else if (this.dataMandSoum.length == 1) {
                                    this.dataMandSoum.forEach((e, i) => {
                                        this.n = this.n + 1;
                                        const t = {
                                            domValues: [
                                                {
                                                    domName: 'R_B_70_10',
                                                    domValue: '1',
                                                },
                                                {
                                                    domName: 'R_B_70_20',
                                                    domValue: e.indRegNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_30',
                                                    domValue: e.staffNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_40',
                                                    domValue: e.positionNm?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_50',
                                                    domValue: e.issuedYmdStr?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_10',
                                                    domValue: e.email?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_20',
                                                    domValue: '',
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_30',
                                                    domValue: e.telNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_40',
                                                    domValue: e.faxNo?.toString(),
                                                },
                                                {
                                                    domName: 'R_B_70_60_10_50',
                                                    domValue: e.mtelNo?.toString(),
                                                },
                                            ],
                                        };
                                        t.domValues.forEach((t, index) => {
                                            list.domValues.push(t);
                                        });
                                    });
                                } else {
                                    const t = {
                                        domValues: [
                                            {
                                                domName: 'R_B_70_10',
                                                domValue: '0',
                                            },
                                            {
                                                domName: 'R_B_70_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_50',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_60_10_10',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_60_10_20',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_60_10_30',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_60_10_40',
                                                domValue: '',
                                            },
                                            {
                                                domName: 'R_B_70_60_10_50',
                                                domValue: '',
                                            },
                                        ],
                                    };
                                    t.domValues.forEach((t, index) => {
                                        list.domValues.push(t);
                                    });
                                }
                                this.myPageService.envoyer(list).subscribe({
                                    next: (res) => {
                                    },
                                    error: (e) => {
                                        if (e.error.text.includes('NORMAL')) {
                                            this.myPageService
                                                .postedocF('N', this.dataDoc[0]?.excStat, this.bizRegNo)
                                                .subscribe();
                                            this.toast.success('saved_successfully');
                                            this.route.navigateByUrl('portail/etat');
                                        } else {
                                            this.myPageService
                                                .postedocF('E', this.dataDoc[0]?.excStat, this.bizRegNo)
                                                .subscribe();
                                            this.toast.error('server_error');
                                        }
                                    },
                                    complete: () => {
                                    },
                                });
                            }
                        },
                    });
                }
            });
    }
}
